<template>
	<div>
		<multiselect
			:placeholder="$t('select')"
			v-model="selected"
			:options="options"
			:class="validateError != '' ? 'box-border-color':''"
			@input="handleInput($event)"
			label="text"
			track-by="value"
			:multiple="false"
			:select-label="''"
			:selected-label="''"
			:deselect-label="''"
			:searchable="true">
			<span slot="noOptions">{{ $t('no_options') }}</span>
			<span slot="noResult">{{ $t('no_result_2') }}</span>
		</multiselect>
		<span class="invalid-feedback-custom"
		      v-show="validateError"
		      v-html="validateError">
        </span>
	</div>
</template>

<script>
	// Helpers
	import handleInput from "@/helpers/handleInput";
	import setSelected from "@/helpers/setSelected";
	
	// Services
	import StaffService from "@/services/StaffService";
	
	export default {
		props: {
			value: {
				type: Number,
				default: null
			},
			validateError: {
				type: String,
				default: ''
			}
		},
		watch: {
			value: function (newValue) {
				this.selected = this.setSelected(newValue, this.options)
			}
		},
		data() {
			return {
				selected: null,
				options: [],
			}
		},
		created() {
			this.getOptions();
		},
		methods: {
			handleInput,
			setSelected,
			getOptions() {
				StaffService.byRole('A')
				            .then(response => {
					            const data = response.data.data;
					            data.forEach((item) => {
						            this.options.push({
							            value: item.user_id,
							            text: item.name + ' ' + item.surname,
						            });
					            });
				            })
				            .then(() => {
					            this.selected = this.setSelected(this.value, this.options)
				            })
			}
		}
	}
</script>
